import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import ApiService from '../../../services/ApiService';
import CourseDetail from '../../coursDetail/courseDetail';
import UserDetailPopUp from '../../../components/Elements/userDetailPopUp/userDetailPopUp';
import axios from 'axios';
import { API_URL } from '../../../config';
import "./CampDetails.css"



 
const CampDetails = (props) => {
    const monthList=["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad","Grudzień"]
    const proxySendURL = `${API_URL}ProxySend`;
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    const history = useHistory();
    const [isPAymentReady, sePaymentReady] = useState(0)
    let [linkPay,setLinkPay] = useState("")
    let globalResponse;
    let amount1 = 0;
    let amount2 = 0;
    let month;
    let [summary, setSummary] = useState(0);
    
    let idLoader;
    const handleChange = (e, value) => {
        
        if(props.choosenInstallmet.includes(e) && e != 1){
  
          let someArray = props.choosenInstallmet.filter(installment => installment != e);
          props.setChoosenInstallmet(someArray)
          setSummary( summary + parseInt(value))
        }
        else{
          let someArray = props.choosenInstallmet.filter(installment => installment == e);
          
          props.setChoosenInstallmet([...props.choosenInstallmet, e])}
        setSummary( summary - parseInt(value))
     
      };
      props.choosenPayVarian.paymentShedule.map((shedule)=>{
        if(props.choosenInstallmet.includes(shedule.countNumber)){
            amount1 += shedule.paymentPositionPrice
        }
    })
    const methodProxySend = () => {
    
       let urlParams ="https://aden-eds-portal-dev.azurewebsites.net/CampThankYou"
      const formData = {
          type: 'OrderPayment',
          body: {
               guid:props.trackingId,          
               paymentMethodsP24:props.paymentP24,               
               returnUrl: urlParams,
               current_LocalizationsID: -1,
          },
      };
     
      axios
          .post(proxySendURL, formData, config)
          .then((response) => {
              globalResponse = response.data.requestId;
              if(response.data.recheck){
                  methodProxyGetMessage();
              } else {
                  document.getElementsByClassName("eds_loader_container")[0].style.display = "none"
              //     if(response.data.message === 'Other created'){
                      
           
                      
              //     }
              //     if(response.data.message === "Fault"){
              
                     
              //     } 
              //     if(response.data.message == 'Other requested'){
              //         // umowa jest w trakcie procesowania uder create
              //         // dispatch(setMessege('Umowa jest w trakcie tworzenia.'));
                
              //         methodProxyGetMessage();
              //     }
               }
          })
          .catch(function (error) {
          console.log(error)
              if (error.response.status == 401) {
                  // history.push('/Error_ogolny');
              }
          });
  };
  const methodProxyGetMessage = () => {
      const proxyGetMessageURL = `${API_URL}ProxyGetMessage?requestId=` + globalResponse;
      axios
          .get(proxyGetMessageURL, config)
          .then((proxyGetMessageUrlResponse) => {
              if (proxyGetMessageUrlResponse.data.responseBody != null) {
                document.getElementsByClassName("eds_loader_container")[0].style.display = "none"
              if(proxyGetMessageUrlResponse.data.responseBody.status == 200){
                  setLinkPay(proxyGetMessageUrlResponse.data.responseBody.body.html)
                  sePaymentReady(20)
     
              }             
                  else if(proxyGetMessageUrlResponse.data.responseBody.status == 401){
                      history.push('/Error_ogolny');
                      sePaymentReady(41)
                   
                  }else  
                      if(proxyGetMessageUrlResponse.data.responseBody.includes("Trying to get property 'paymentCardID' of non-object in") ){
                          sePaymentReady(42)
                          //Wiadomość nie można było przygotować płatności ponieważ brak karty
                          //Co robić w tej sytuacji 
                  }else{
                          sePaymentReady(40)
                      }
                  
                  
              } else if (proxyGetMessageUrlResponse.data.recheck == true) {
                  setTimeout(() => methodProxyGetMessage(), 10000);
              } else if (proxyGetMessageUrlResponse.data.recheck == false) {
                  sePaymentReady(40)
              }
          })
          .catch(function (error) {
              if (error.response != null) {
                  if (error.response.status == 401) {
                      // history.push('/Error_ogolny');
                      sePaymentReady(40)
                  }
              } else {
                  // window.location.replace(
                  //     'https://aden-eds-portal-dev.azurewebsites.net/#/Error_ogolny'
                  // );
                  sePaymentReady(40)
              }
          });
  };
  useEffect(()=>{
    methodProxySend()
  },[])
    return <> 
    <div className="wrapperSumaryCamp">
    <CustomTittle>Pomyślnie dokonano zakupu obozu</CustomTittle>
        <div className="wrapperSumaryCampRow">
            <div className="wrapperSumaryCampColumn">
                <CourseDetail wrapNavigator={props.wrapNavigator}  setWrapNavigator={props.setWrapNavigator} setHeader={(e)=>{props.setHeader(e)}} header={props.header}></CourseDetail>
            </div>
            <div className="wrapperSumaryCampColumn toRight">
                <div className=" wrapperSumaryCampPopUp">
                    <UserDetailPopUp
                                
                                    title="Uczestnik:"
                                    label={
                                        props.parcipient != undefined?props.parcipient:props.userData.name + " " + props.userData.lastName
                                    }
                                   
                    ></UserDetailPopUp>
                   {
                
                Object.keys(props.paymentMethodList).map((key, index) => (
                  props.paymentMethodList[key]?
                  <UserDetailPopUp
                              
                                title="Metoda płatności: "
                                label={
                                  key
                                }
                                onclick={()=>{}}
                               
                              
                  ></UserDetailPopUp>:""
                ))
              }
                     <UserDetailPopUp
                                
                                title="Wariant cenowy:"
                                label={
                                    "płatność ratalna"
                                }
                               
                    ></UserDetailPopUp>
             
            </div></div>
        </div>
      <div className="PaymentTable">
    
        <div className='Installment_summary'>
          <div className='Installment_summaryDetails'> 
         
            <div className='amountInstallment'><p>DO ZAPŁATY:</p>    { <p>{amount1.toFixed(2).toString().replace(".",",")} ZŁ</p>}</div>
          </div> 
          {isPAymentReady == 0? <div className="awaitPayment"><p className="awaitPaymentText">Trwa przygotowywanie płatności</p> <div className="dot"></div> <div className="dot"></div> <div className="dot"></div> </div>:""}
          {isPAymentReady == 20? <CustomButtons clickFunction={()=>{window.location.replace(linkPay)}} classButton="solid" size="big">PRZEJDŹ DO PŁĄTNOŚCI</CustomButtons>:""}
          {isPAymentReady == 40? <p>Nie mogliśmy przygotować twoje płątności. Możesz ponowić próbę dokonania płatności w panelu klienta.</p>:""}
          {isPAymentReady == 41? <p>Twoja sesja wygasła! Zaloguj się ponownie.</p>:""}
         {isPAymentReady == 42? <p>Nie mogliśmy przygotować twoje płątności, ponieważ wybrałem płatność kartą jako twoją formę płatności a nie masz podpięte żadnej karty płatniczej. Karte płatniczą możęsz dodać w panelu klienta.</p>:""}
        </div> 
      </div>  
    </div>
    </>;
    }

export default CampDetails;
